"use client";

import { http } from "../httpHandler";
import { links } from "@/constants";
import { TServerErrorResponse } from "@/types";

export interface UploadPemFileRequest {
  fileBuffer: string;
  emoneyClientId: string;
}

export interface UploadPemFileResponse {
  message: string;
}

export interface IsConnectedResponse {
  isConnected: boolean;
}

export const uploadEmoneyPemFile = async (
  data: UploadPemFileRequest,
): Promise<UploadPemFileResponse> => {
  try {
    const response = await http.post<UploadPemFileResponse>(
      links.emoney.uploadPemFile,
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const checkEmoneyConnection = async (): Promise<IsConnectedResponse> => {
  try {
    const response = await http.get<IsConnectedResponse>(
      links.emoney.isConnected,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
